import { InternalGroupModel } from './internal-group.model';

export namespace FamilyModel {
    export type Family = InternalGroupModel.InternalGroup;
}
